/// <reference path='../_all.ts' />


module pze {
  /**
   * Angular Service http://stackoverflow.com/questions/19447886/how-can-i-define-an-angularjs-service-using-a-typescript-class-that-doesnt-poll
   */
  export class PzeService implements IPzeService {
    static $inject = [
      '$http',
      'CacheFactory', 
      'userService',
      '$filter',
    ];

    constructor(
      // Add the parameter and type definition.
      public $http: ng.IHttpService,
      private CacheFactory: CacheFactory.ICacheFactory,
      private userService: user.UserService,
      private $filter: ng.IFilterService
    ) { } 

    public timesByDate(dayFrom: Date, dayTo: Date) : ng.IHttpPromise<api_photometer.GraphQlResponse<api_photometer.timesByDate_Return>> {

      
      var dayFromStr = this.$filter('date')(dayFrom, "yyyy-MM-dd");
      var dayToStr = this.$filter('date')(dayTo, "yyyy-MM-dd");

      const query = `{
                              timesByDate(dayFrom: "${dayFromStr}", dayTo: "${dayToStr}") {
                                    day
                                    totalWorkTime
                                    totalWorkHours
                                    totalPaidTime
                                    totalPaidHours
                                    totalBreakTime
                                    totalBreakHours
                                    totalSystemPaidHours
                                    totalSystemPaidTime
                                    totalSystemShouldHours
                                    totalSystemShouldTime
                                    totalSystemBreakTotalHours
                                    totalSystemBreakTotalTime
                                    totalSystemBreakPaidHours
                                    totalSystemBreakPaidTime
                                    totalSystemBreakLunchHours
                                    totalSystemBreakLunchTime
                                    totalLunchBreakTime
                                    totalLunchBreakHours
                                    projectedEndOfWorkday
                                    entries {
                                        clockingStartType
                                        clockingStartTime
                                        clockingStartHours
                                        clockingEndType
                                        clockingEndTime
                                        clockingEndHours
                                        durationKind
                                        hours
                                        time
                                        paidHours
                                        paidTime
                                    }
                              }
                          }`;

      var tokenPromise = this.userService.getJwtToken();
      return tokenPromise.then((token: string): ng.IHttpPromise<api_photometer.GraphQlResponse<api_photometer.timesByDate_Return>> => {
        return this.$http<boolean>({
          method: "POST"
          , url: pglob.RouteData.PhotometerApiBaseUrl + "/graphql"
          , headers: { 
            'Authorization': 'Bearer ' + token
          }
          , params: {
          }
          , data: { "query": query
                    , "variables": {}
                  }
        }).then((response: { data: any }): any => { //success
          return response;
        })
          .catch((response) => {
            throw "Error in 'PzeService.timesByDate' " + response.status;
          });
      });      

    }


    public personalIcalUrl() : ng.IHttpPromise<api_photometer.GraphQlResponse<api_photometer.personalIcalUrl_Return>> {

      const query = `{
                      personalIcalUrl
                    }`;

      var tokenPromise = this.userService.getJwtToken();
      return tokenPromise.then((token: string): ng.IHttpPromise<api_photometer.GraphQlResponse<api_photometer.personalIcalUrl_Return>> => {
        return this.$http<boolean>({
          method: "POST"
          , url: pglob.RouteData.PhotometerApiBaseUrl + "/graphql"
          , headers: { 
            'Authorization': 'Bearer ' + token
          }
          , params: {
          }
          , data: { "query": query
                    , "variables": {}
                  }
        }).then((response: { data: any }): any => { //success
          return response;
        })
          .catch((response) => {
            throw "Error in 'PzeService.timesByDate' " + response.status;
          });
      });      

    }

    

  }

}
